<div class="is-flex is-column is-justify-space-between is-fullheight" *ngIf="vm$ | async as vm" [formGroup]="form">

  <div class="is-flex is-column gap-24 text-align-center">

    <div class="is-flex is-justify-space-between">
      <app-icon [routerLink]="['..']" skipLocationChange="true" class="text-24 is-cursor-pointer" name="next" [style.transform]="'rotate(180deg)'"></app-icon>
      <app-text class="text-22 is-family-semiBold">{{ 'common-app.__UNPLACED_PRODUCT_WEBAPP_SETUP_TITLE' |  AsyncLang | async }}</app-text>
      <app-icon></app-icon>
    </div>

    <app-text>{{ 'common-app.__UNPLACED_PRODUCT_WEBAPP_EXPLICATION' |  AsyncLang | async }}</app-text>

  </div>

  <div class="rooms is-flex-grow-1 is-flex is-column gap-24" cdkDropListGroup cdkScrollable>

    <div class="rooms-header bg-grey-hover-10 is-flex is-justify-space-between">
      <app-text class="is-family-bold text-22">{{ 'common-app.__UNPLACED_PRODUCT_WEBAPP_YOUR_ROOMS' |  AsyncLang | async }}</app-text>
      <div [routerLink]="['add-room']" skipLocationChange="true" class="is-flex gap-8 text-netatmo-orange is-cursor-pointer">
        <app-icon name="plus" class="text-24"></app-icon>
        <app-text class="is-family-medium">{{ 'common-app.__ADD_ROOM' |  AsyncLang | async }}</app-text>
      </div>
    </div>

    <div class="room is-flex is-column gap-24" *ngFor="let data of vm">
      <div class="is-flex is-justify-space-between">
        <div class="room-container is-flex-grow-1 is-align-center is-flex gap-8">
          <app-icon class="text-32" [name]="RoomsAssets[data.room.type].icon"></app-icon>
          <app-input-text class="is-family-semiBold has-spacing-left-xxs"
            [formControlName]="data.room.id"
            [hasEdit]="false"
            autocomplete="off">
          </app-input-text>
          <app-icon class="room-edit text-24" name="edit"></app-icon>
        </div>
      </div>
      <div class="warning" *ngIf="roomHasMultipleDevices(data.modules)">
        <div class="is-flex text-grey-0">
          <div class="is-relative is-flex is-justify-center  has-spacing-right-xs">
            <app-icon
                class="is-overlay is-flex is-justify-center text-24 is-family-semiBold has-text-centered"
                [name]="'warning-circle-composition-overlay'">
            </app-icon>
            <app-icon name="warning-circle-composition-background" class="text-orange-alert has-margin-centered text-24"></app-icon>
          </div>
          
          <app-text class="text-14 text-orange-alert" [text]="'common-app.__UNPLACED_PRODUCT_WEBAPP_WARNING' | AsyncLang | async"></app-text>

        </div>
        <app-text class="text-14 text-grey-90" [text]="'common-app.__UNPLACED_PRODUCT_WEBAPP_WARNING_SENSORS' | AsyncLang | async"></app-text>

      </div>

      <div class="modules is-flex is-column gap-8" cdkDropList [cdkDropListData]="data.modules" [cdkDropListAutoScrollStep]="20" (cdkDropListDropped)="drop($event)" [cdkDropListSortPredicate]="sortPredicate">
        <div class="module-container" *ngFor="let module of data.modules">
          <div class="module bg-grey-hover-10 is-flex is-justify-space-between gap-4" [class.focus]="inputText.isFocus" cdkDrag cdkDragLockAxis="y">
            <div class="placeholder" *cdkDragPlaceholder></div>
            <div class="is-flex is-justify-space-between is-flex-grow-1 is-align-center gap-8">
              <app-icon [name]="ModulesAssets[module.type].icon" class="text-32"></app-icon>
              <app-input-text #inputText class="is-family-semiBold has-spacing-left-xxs"
                [formControlName]="module.id"
                [hasEdit]="false"
                autocomplete="off">
              </app-input-text>
            </div>
            <app-icon class="module-edit text-24" name="edit"></app-icon>
            <app-icon *ngIf="!inputText.isFocus" class="module-drag text-24" name="drag"></app-icon>
          </div>
        </div>
      </div>

    </div>

  </div>

  <lay-button class="is-flex-button" (click)="placeProducts(vm)">
    <button class="is-primary-button" [class.is-loading]="loader$ | async">
      <app-text [text]="'common-app.__CONFIRM' | LANG"></app-text>
    </button>
  </lay-button>

</div>

<router-outlet></router-outlet>
